<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="24"
        viewBox="0 -2 22 20"
        fill="none"
    >
        <path
            d="M14.9012 8.09846C14.9012 4.59913 11.9002 1.79966 8.3819 1.79966C4.76009 1.79966 1.86265 4.59913 1.86265 8.09846C1.86265 11.4978 4.76009 14.3973 8.3819 14.3973C11.9002 14.3973 14.9012 11.4978 14.9012 8.09846ZM15.2116 12.6976L21.2135 18.3965C22.0413 19.2963 20.7995 20.5961 19.8682 19.6963L13.9698 13.9973C12.5211 15.3971 10.555 16.1969 8.3819 16.1969C3.72529 16.1969 0 12.4976 0 8.09846C0 3.59932 3.72529 0 8.3819 0C12.935 0 16.7638 3.59932 16.7638 8.09846C16.7638 9.79814 16.1429 11.3978 15.2116 12.6976Z"
            fill="#046791"
        />
    </svg>
</template>
